import React from 'react';
import { Grid } from '@material-ui/core';
import { useSelector } from 'react-redux';

import yup from '../../../utility/yup';
import {
  ItemForm,
  FormSwitch,
} from '../../../components';
import { useTitle } from '../../../hooks';
import { Loadable } from '../../../store/types';
import { Organization } from '../../../types/items';
import { selectIsAdmin } from '../../../store/modules/users/selectors';

type Props = {
  creatingMode?: boolean;
  record: Loadable<Organization>;
  onSubmit: (record: Organization) => void;
};

const accountSchema = yup.object().shape({
  pays_user_subscriptions: yup.boolean(),
  pays_user_non_subscriptions: yup.boolean(),
});

const BillingForm = ({
  record: { loading, data },
  onSubmit,
}: Props) => {
  useTitle('Billing');
  const isAdmin = useSelector(selectIsAdmin);

  return (
    <ItemForm
      initialValues={data}
      validationSchema={accountSchema}
      onSubmit={onSubmit}
      loading={loading}
      editPermitted={Boolean(data?.permissions.can_edit)}
      enableReinitialize
      preventCancelChanges
    >
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <FormSwitch
            label="Pay organization user subscriptions?"
            name="pays_user_subscriptions"
            disabled={!isAdmin}
          />
        </Grid>
        <Grid item xs={12}>
          <FormSwitch
            label="Pay organization user production costs?"
            name="pays_user_non_subscriptions"
            disabled={!isAdmin}
          />
        </Grid>
      </Grid>
    </ItemForm>
  );
};

export default BillingForm;
